export default __webpack_public_path__ + "03e96e008bb80a676d84d5470944f6c6.svg";